import { Container, Row, Col } from 'react-bootstrap';
import './Careers.css'; 
import React, { useState, useEffect, useContext } from 'react'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const Careers = () => {
    
    const jobOpenings = [];
    const careerContact = {
        email: DefaultData?.DEFAULTCOMPANYEMAIL,
        phone: DefaultData?.DEFAULTCOMPANYPHONENUMBER
    };

    
    const landingData = useContext(LandingContext);
        const pageStyles = {
            '--theme-primary-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
            '--theme-secondary-color': landingData?.themeColor2 || DefaultData?.THEMECOLOR2
        };
    return (
        // UPDATED: Apply the dynamic styles to the main container
        <div className="main-content" style={pageStyles}>
            <div className="careers-hero-section">
                <Container className="text-center">
                    <h1 className="hero-title">Join Our Team</h1>
                    <p className="hero-subtitle">Be a part of a dynamic and passionate team dedicated to redefining the travel experience.</p>
                </Container>
            </div>

            <div className="page-content">
                <Container>
                    <section className="culture-section text-center">
                        <h2 className="section-title">Our Work Culture</h2>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <p className="lead-text">
                                    At {DefaultData?.DEFAULTBRANDNAME}, we foster a climate of trust, support, and open communication. We provide our people with accountability, responsibility, and the resources they need to reach their full potential. We encourage an innovative and resourceful spirit.
                                </p>
                            </Col>
                        </Row>
                    </section>

                    <section>
                        <h2 className="section-title text-center">Current Openings</h2>
                        {jobOpenings.length > 0 ? (
                            <Row className="g-4">
                                {/* This part remains for when you add job listings */}
                            </Row>
                        ) : (
                            <div className="text-center no-openings-card">
                                <h5>No Current Openings</h5>
                                <p>We are always looking for talented individuals. Feel free to reach out to us with your resume for future opportunities.</p>
                                
                                <div className="career-contact-info-text mt-4">
                                    <a href={`mailto:${careerContact.email}`}>
                                        <i className="ri-mail-line"></i> {careerContact.email}
                                    </a>
                                    <span className="contact-divider">|</span>
                                    <a href={`tel:${careerContact.phone.replace(/\s/g, '')}`}>
                                        <i className="ri-phone-line"></i> {careerContact.phone}
                                    </a>
                                </div>
                            </div>
                        )}
                    </section>
                </Container>
            </div>
        </div>
    );
};

export default Careers;